/* eslint-disable */
import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { getLocale } from './utils/commons';
import { actionCreators, AuthData } from './store/profile/CurrentProfile';
import { actionCreator as uiAction } from './store/uiproperties/UIState';
import moment from "moment";
import 'moment/min/locales';


moment.locale(getLocale().toLowerCase());

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

let storageData = localStorage.getItem("authData");

let year = new Date().getFullYear();

let authData: AuthData = null;

if (storageData !== undefined && storageData != null && storageData != "undefined" && storageData != "null") {
    authData = JSON.parse(storageData);
}

if (authData !== undefined && authData != null && authData.token !== undefined && authData.token != null) {
    store.dispatch(actionCreators.setAuthData(authData) as any);
    store.dispatch(actionCreators.getProfileInfoAndPermission() as any);
}

store.dispatch(uiAction.supportNativeDateInput() as any);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

ReactDOM.render(
    <p className="text-eurorounders">
        &copy; {year} Euro Rounders
    </p>,
    document.getElementById('er-footer'));

registerServiceWorker();
